export default __webpack_public_path__ + "static/media/icon_discovery.a422c174.svg";